import React, { Component } from 'react';
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";
import { FormGroup, FormFeedback, Input, Button, ListGroupItem, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import { data } from '../../constants/Constants';
import color from '../../constants/Colors';
import { getDataFiltros } from '../../store/sagas/pedidoApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { BuscarCodigoDescripcionPrincipal, BuscarCodigoDescripcion, BuscarSistemaPrincipal, BuscarSistema, BuscarKit } from '../../store/sagas/pedidoApi';
import { AgregarProductoFavorito } from '../../store/sagas/favoritoApi';
import { AgregarProductoPedido } from '../../store/sagas/carritoApi';
import { notificacion, getStatePage } from '../../utilitarios/util';
import Slider from "react-slick";
import Pagination from '../reusable/Pagination'
import { AuthContext } from "../../store/provider/AuthProvider";
import CounterInput from '../reusable/CounterInput';
import ModalAddCart from "../reusable/modals/AddCart";
import ModalImageZoom2 from '../reusable/modals/ImageZoom2';
import ModalKit from '../reusable/modals/kit';
import TooltipLeyenda from '../reusable/TooltipLeyenda';
import BtnCompatible from '../reusable/BtnCompatible';
import CardPrecios from '../reusable/CardPrecios';
import CardPrecioOferta from '../reusable/CardPrecioOferta';
import Spinner from "../reusable/Loader";
import ModalCompatible from '../reusable/modals/Compatible';

const CardResultado = ({ item, auth, event, eventCounter, eventFavorito, zoom, kit, compatible }) => {
  console.log("CardResultado==>", item);
  return (
    <div className="card_product_horizontal">
      <div className="cphLeftImage">
        {(item.modelos.length > 0) ?
          <button className='btn-icon'
            style={{ position: 'absolute', left: 6, top: 6 }}
            type="button"
            onClick={() => compatible(item.modelos)}
          >
            <SvgAssets icon="icon-compatible" fill={color.azulClaro} />
          </button> : null}
        <div style={{ cursor: 'pointer', margin: 'auto' }} onClick={() => zoom(item.fotos)}>
          <img src={item.pathImage} />
        </div>
      </div>
      <div className="cphTextCenter">
        <h6 className="paragraph-2 bold morado mb-1" style={{ wordBreak: 'break-word' }}>{item.maktx}</h6>
        <span className="paragraph-3 light mb-3" style={{ color: color.grisOscuro }}>SKU: {item.matnr}</span>
        {/* <span className="paragraph-3 previousPrice" style={{ color: color.grisOscuro }}>{item.precioPublico}</span>
        <strong className="paragraph-3 bold naranja">{item.precioPVD}</strong>
        <span className="paragraph-3">{item.precioPVP}</span> */}
        <CardPrecios data={item.precios} escalas={item.escalas} cantidad={item.cantidad} className="cardPrice" />
        <div className="options">

          {item.flagKit ? (
            <button className='btn-icon' onClick={() => kit(item.matnr, item.maktx)}>
              <SvgAssets icon="icon-kit" fill={'#ED7F9A'} />
            </button>
          ) : (
            <>
              {/* <BtnCompatible IdInput={item.idInput} texto={item.mensajeCompatible} /> */}
              <button className='btn-icon'
                type="button"
                onClick={() => eventFavorito({
                  codigo: item.matnr, descripcion: item.maktx,
                  moneda: item.waers, pantalla: data.Pantalla.BuscarPedidoCodigo.Producto
                }, item.favorito, item.indice)}
              >
                <SvgAssets icon="icon-star" fill={item.favorito ? color.amarillo : color.celeste} />
              </button>
            </>
          )}
        </div>
      </div>
      <div className="cphCounterInput" style={{ backgroundColor: color.morado, justifyContent: 'space-between' }}>
        <CounterInput
          IdInput={item.idInput}
          vertical
          background={color.morado}
          color={"#fff"}
          borderColor={"#fff"}
          data={item}
          eventCounter={eventCounter}
        />
        <button
          className="btn-icon mt-3"
          disabled={item.cantidad == 0}
          onClick={() => event(auth.carritoProdctos, auth.setcarritoProdctos, {
            codigo: item.matnr,
            descripcion: item.maktx,
            precioOferta: item.poferta,
            precioPublico: item.plista,
            precioFinal: item.pFinal,
            unidadMedida: item.meins,
            precioPVD: item.precioPVD,
            precioPVP: item.precioPVP,
            precioPublico: item.precioPublico,
            moneda: item.waers,
            pathI: item.pathImage,
            precios: item.precios,
            cantidadOriginal: item.cantidad,
            cantidad: item.cantidad,
            pantalla: data.Pantalla.BuscarPedidoCodigo.Producto,
            indice: item.indice,
            flagKit: item.flagKit,
            escalas: item.escalas
          })}
          type="button"
        >
          <SvgAssets icon="icon-add-cart" />
        </button>
      </div>
    </div>
  )
}

const CardRepuestos = ({ item, event, zoom }) => {
  return (
    <div className="card_product_horizontal card_repuesto">
      <div className="cphLeftImage">
        <div style={{ cursor: 'pointer' }} onClick={() => zoom(item.linkimg)}>
          <img src={item.linkimg} />
        </div>
      </div>
      <div className="cphTextCenter">
        <h6 className="paragraph-2 bold verde mb-1">{item.sistemaweb}</h6>
        {/* <Link to="/repuestos" style={{textDecoration:'none'}}> */}
        <button
          className="btn-small"
          type="button"
          onClick={() => { event(item) }}
        ><SvgAssets icon="icon-list" fill="#fff" />Ver repuestos</button>
        {/* </Link> */}
      </div>
    </div>
  )
}

const ProductoDestacado = ({ item, index, event, eventCounter, eventFavorito, auth, zoom, tipoBuscador, compatible }) => {

  return (
    <div className="card_product_vertical">
      <div style={{ cursor: 'pointer' }} onClick={() => zoom(item.fotos)}>
        <img className="product-img" src={item.pathI} />
      </div>
      <h6 className="paragraph-2 bold azul">{item.maktx}</h6>
      <span className="paragraph-3 sku">SKU: {item.matnr}</span>
      <div>
        {/* <span className="paragraph-3 previousPrice">{item.precioPublico}</span>
        <span className="paragraph-3 bold" style={{ color: color.naranja }}>{item.precioPVD}</span>
        <span className="paragraph-3">{item.precioPVP}</span> */}
        <CardPrecios data={item.precios} escalas={item.escalas} cantidad={item.cantidad} className="cardPrice" />
      </div>
      <div className="counter">
        <CounterInput
          IdInput={item.idInput}
          background={"#fff"}
          color={"#316ACD"}
          borderColor={"#E2E2E2"}
          data={item}
          eventCounter={eventCounter}
        />
      </div>
      <div className="options">
        {tipoBuscador == 1 ?
          <BtnCompatible IdInput={item.indice} texto={item.mensajeCompatible} backgroundColor={color.azulClaro} color={'#fff'} />
          // <button className='btn-icon'
          //   type="button"
          //   onClick={() => compatible(item.mensajeCompatible)}
          // >
          //   <SvgAssets icon="icon-compatible" fill={color.azulClaro} />
          // </button>
          : null}
        <button className="btn-icon"
          type="button"
          onClick={() => eventFavorito({
            codigo: item.matnr, descripcion: item.maktx,
            moneda: item.waers, pantalla: data.Pantalla.BuscarPedidoCodigo.Destacado
          }, item.favorito, item.indice)}
        >
          <SvgAssets icon="icon-star" fill={item.favorito ? color.amarillo : color.celeste} />
        </button>
        <button className={`btn-icon${(item.cantidad == 0 ? " disabled" : "")}`}
          disabled={item.cantidad == 0}
          onClick={() => event(auth.carritoProdctos, auth.setcarritoProdctos, {
            codigo: item.matnr,
            descripcion: item.maktx,
            precioOferta: item.poferta,
            precioPublico: item.plista,
            precioFinal: item.pfinal,
            unidadMedida: item.meins,
            precioPVD: item.precioPVD,
            precioPVP: item.precioPVP,
            precioPublico: item.precioPublico,
            moneda: item.waers,
            pathI: item.pathI,
            precios: item.precios,
            cantidadOriginal: item.cantidad,
            cantidad: item.cantidad,
            pantalla: data.Pantalla.BuscarPedidoCodigo.Destacado,
            indice: item.indice,
            escalas: item.escalas
          })}
          type="button"

        >
          <SvgAssets icon="icon-add-cart" className="add-cart" />
        </button>
      </div>
    </div>
  )
}

const ProductoVendido = ({ item, index, event, eventCounter, eventFavorito, auth, zoom }) => {
  return (
    <div className="card_product_horizontal gradient_blue" style={{ filter: 'none' }}>
      <div className="cphLeftImage">
        <div style={{ cursor: 'pointer' }} onClick={() => zoom(item.pathI)}>
          <img src={item.pathI} />
        </div>
      </div>
      <div className="cphTextCenter">
        <h6 className="paragraph-2 bold mb-1" style={{ color: '#fff' }}>{item.maktx}</h6>
        <span className="paragraph-3 mb-3 light" style={{ color: '#fff' }}>SKU: {item.matnr}</span>
        {/* <span className="paragraph-3 previousPrice" style={{ color: '#fff' }}>{item.precioPublico}</span>
        <strong className="paragraph-3 bold naranja">{item.precioPVD}</strong>
        <span className="paragraph-3" style={{ color: '#fff' }}>{item.precioPVP}</span> */}
        <CardPrecioOferta data={item.precios} className="cardPrice" />
        <div className="text-left mt-2">
          <button className='btn-icon' type="button"
            onClick={() => eventFavorito({
              codigo: item.matnr, descripcion: item.maktx,
              moneda: item.waers, pantalla: data.Pantalla.BuscarPedidoCodigo.Vendido
            }, item.favorito, item.indice)}>
            <SvgAssets icon="icon-star" fill={item.favorito ? color.amarillo : color.celeste} />
          </button>
        </div>
      </div>
      <div className="cphCounterInput" style={{ backgroundColor: color.azulClaro, justifyContent: 'space-between' }}>
        <CounterInput
          IdInput={item.idInput}
          vertical
          background={color.azulClaro}
          color={"#fff"}
          borderColor={"#fff"}
          data={item}
          eventCounter={eventCounter}
        />
        <button className={`mt-3 btn-icon${(item.cantidad == 0 ? " disabled" : "")}`}
          disabled={item.cantidad == 0}
          onClick={() => event(auth.carritoProdctos, auth.setcarritoProdctos, {
            codigo: item.matnr,
            descripcion: item.maktx,
            precioOferta: item.pOfe,
            precioPublico: item.pPub,
            precioFinal: item.pFin,
            precioPVD: item.precioPVD,
            precioPVP: item.precioPVP,
            precioPublico: item.precioPublico,
            unidadMedida: item.meins,
            moneda: item.waers,
            cantidadOriginal: item.cantidad,
            cantidad: item.cantidad,
            pantalla: data.Pantalla.BuscarPedidoCodigo.Vendido,
            precios: item.precios,
            pathI: item.pathI,
            indice: item.indice,
            escalas: item.escalas
          })}
          type="button">
          <SvgAssets icon="icon-add-cart" className="add-cart" />
        </button>
      </div>
    </div>
  )
}

export class GenerarPedido extends Component {
  static displayName = GenerarPedido.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      isMobile: isMobile,
      isSearch: false,
      dealer: {},
      linea: {},
      asociado: {},
      tipoBuscador: 1,
      isEditable: true,
      loading: false,
      filtroAnio: [],
      filtroModelo: [],
      filtroVehiculo: [],
      selectedAnioValue: '',
      selectedModeloValue: '',
      selectedVehiculoValue: '',
      textBuscador: '',
      textBuscadorOri: '',
      dataResult: { repuestos: [], destacados: [], vendidos: [], detalleKit: [] },
      titulo: '',
      pdf: '',
      page: 1,
      size: data.PageSizeVehiculos,
      currentPage: 1,
      errorCodigo: false,
      errorVehiculo: false,
      addToCart: false,
      dataToCard: {},
      modalZoom: false,
      modalKit: false,
      modalCompatible: false,
      mensajeCompatible: '',
      imgZoom: "",
      listImgZoom: [],
      listImgZoom: [],
      params: {},
      kit: '',
      dataCompatible: [],
    };
  }

  showModalCart = () => {
    this.setState(prevState => ({
      addToCart: !prevState.addToCart
    }));
  }
  toggleModalZoom = (img) => {
    this.setState(prevState => ({
      modalZoom: !prevState.modalZoom,
      imgZoom: Array.isArray(img) ? "" : img,
      listImgZoom: Array.isArray(img) ? img : [],
    }));
  }
  toggleModalCompatible = (texto) => {
    this.setState(prevState => ({
      modalCompatible: !prevState.modalCompatible,
      dataCompatible: texto ?? []
    }));
  }
  toggleModalKit = (matnr, maktx) => {
    this.setState(prevState => ({
      modalKit: !this.state.modalKit,
    }));
    if (!this.state.modalKit) {
      this.setState(prevState => ({
        kit: maktx,
      }));
      this.postBuscarKit(this.state.dealer, this.state.linea, matnr)
    }
  }
  showCarrito = () => {
    this.setState({ addToCart: false, loading: true }, () => {
      setTimeout(() => {
        this.setState({ loading: false })
        this.props.history.push('/carrito');
      }, 1000);
    });
  }

  loadInBrowser = () => {
    window.open(this.state.pdf, "_blank");
  };


  checkParams(fn = () => { }) {
    const { state } = this.props.location;
    let parametro = null;
    if (state) {
      parametro = state.datosBuscador;
    }
    console.log("checkParams con data===>", parametro);
    this.setState({
      params: parametro
    }, fn)
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }
  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0)
      this.checkParams(() => {
        let result = localStorageCustom.prototype.getUsuario();
        this.setState({ dealer: result.dealer, linea: result.linea, asociado: result.asociado },
          () => {

            this.getAnios(data.FiltroPedito.ComboAnio);
            if (this.state.params) {
              this.setState({
                isSearch: true,
                tipoBuscador: 2,
                selectedAnioValue: this.state.params.selectedAnioValue,
                selectedModeloValue: this.state.params.selectedModeloValue,
                selectedVehiculoValue: this.state.params.selectedVehiculoValue
              },
                () => {

                  this.getFiltros(data.FiltroPedito.ComboModelo, this.state.params.selectedAnioValue);
                  this.getFiltros(data.FiltroPedito.ComboVehiculo, this.state.params.selectedAnioValue, this.state.params.selectedModeloValue, true);



                })
            }
          });
      });
    } else
      window.location.href = "/";
  }


  render() {
    const { isMobile, isSearch, errorCodigo, errorVehiculo, textBuscador, tipoBuscador, isEditable, loading, filtroAnio, filtroModelo, filtroVehiculo, selectedAnioValue, selectedModeloValue, selectedVehiculoValue, dataResult, page, currentPage, size, titulo } = this.state;
    const navigation = this.props.navigation;
    const colorEditable = isEditable ? color.verdeClaro : color.celeste;
    const auth = this.context;

    var slider_destacados = {
      dots: false,
      infinite: false,
      arrows: false,
      speed: 500,
      slidesToShow: 4,
      // slidesToScroll: 1,
      // variableWidth: true
    };
    var slider_vendidos = {
      dots: false,
      infinite: false,
      arrows: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      variableWidth: true
    };

    let component = (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Generar pedido </h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li>Pedidos</li>
              <li>Generar Pedido</li>
            </ul>
          </Container>
        </div>
        <div className="container_whit_menu">
          <div className="container_left">
            <div className="card_busqueda_pedido">
              <div className="textContent">
                <h6 className="paragraph-2 morado bold"><SvgAssets icon="icon-codigo" fill={color.morado} />Buscador por Producto</h6>
                <p>Esta opción te permitirá realizar búsquedas de repuestos por código o descripción.</p>
              </div>
              <form className="busqueda-pedido">
                <FormGroup className="mb-0">
                  <Input type="text" name="descripcion" placeholder="SKU o Descripción" className={`morado${errorCodigo ? " ph-error" : ""}`} value={textBuscador} onChange={(textBuscador) => this.setText(textBuscador)}
                    onKeyPress={(e) => { if (e.which == 13 || e.which == 10) e.preventDefault(); }}
                    onKeyUp={(e) => { if (e.keyCode == 13 || e.keyCode == 10) { e.preventDefault(); this.IrBuscar(1, isMobile); } }}
                  />
                  <button type="button" className='btn-icon rounded' style={{ backgroundColor: color.morado }} onClick={() => { this.IrBuscar(1, isMobile) }}>
                    <SvgAssets icon="icon-lupa" fill="#fff" />
                  </button>
                </FormGroup>
                {(errorCodigo) ? <FormFeedback>Debe incluir al menos 5 caracteres, si requiere puede completar dicha cantidad colocando <span className="bold">espacios en blanco</span> al final</FormFeedback> : null}
              </form>
            </div>
            <div className="card_busqueda_pedido">
              <div className="textContent">
                <h6 className="paragraph-2 verde bold"><SvgAssets icon="icon-moto" fill={color.verdeClaro} />Buscador por Vehículo</h6>
                <p>Esta opción te permitirá realizar búsquedas de repuestos por vehículo.</p>
              </div>
              <form className="busqueda-pedido">
                <FormGroup>
                  <Input
                    type="select"
                    name="select"
                    className="verde"
                    style={{ flex: 0.5 }}
                    value={selectedAnioValue}
                    onChange={(itemValue, itemIndex) => this.setSelectedValue(itemValue, data.FiltroPedito.ComboAnio)}
                  >
                    <option>Año</option>
                    {(filtroAnio.length > 0) ? filtroAnio.map((data, index) => {
                      return (
                        <option key={index + 1} value={data.id}>{data.descripcion}</option>
                      )
                    }) : null}
                  </Input>
                  <Input
                    type="select"
                    name="select"
                    className="verde ml-2"
                    value={selectedModeloValue}
                    onChange={(itemValue, itemIndex) => this.setSelectedValue(itemValue, data.FiltroPedito.ComboModelo)}>
                    <option>Modelo</option>
                    {(filtroModelo.length > 0) ? filtroModelo.map((data, index) => {
                      return (
                        <option key={index + 1} value={data.id}>{data.descripcion}</option>
                      )
                    }) : null}
                  </Input>
                </FormGroup>
                <FormGroup className="mb-0">
                  <Input
                    type="select"
                    name="select"
                    className="verde"
                    value={selectedVehiculoValue}
                    onChange={(itemValue, itemIndex) => this.setSelectedValue(itemValue, data.FiltroPedito.ComboVehiculo)}>
                    <option>Vehículo</option>
                    {(filtroVehiculo.length > 0) ? filtroVehiculo.map((data, index) => {
                      return (
                        <option key={index + 1} value={data.descripcion} >{data.descripcion}</option>
                      )
                    }) : null}
                  </Input>
                  <button type="button" className='btn-icon rounded' style={{ backgroundColor: color.verdeClaro }} onClick={() => { this.IrBuscar(2, isMobile) }}>
                    <SvgAssets icon="icon-lupa" fill="#fff" />
                  </button>
                </FormGroup>
                {(errorVehiculo) ? <FormFeedback>Debe seleccionar el año, modelo y vehículo</FormFeedback> : null}
              </form>
            </div>
            <Link className='btn-block bg_transparent' to="/pedido-sugerido">PEDIDO SUGERIDO</Link>
            <Link className='btn-block bg_transparent' to="/pre-pedidos">PRE-PEDIDO<br />(Pasar Pre-Pedido)</Link>
            <Link className='btn-block bg_transparent'
              to={
                {
                  pathname: "/historial-pedidos",
                  state: { estad: null }
                }
              }
              style={{ backgroundColor: color.azulClaro, color: '#fff' }}>
              REPETIR PEDIDO ANTERIOR
            </Link>
          </div>
          <div className="container_right">
            {isSearch == true ?
              <div>
                {tipoBuscador == 2 ?
                  <div className="manual">
                    <h6 className="title verde mb-0">{titulo}</h6>
                    <button
                      className="btn-small"
                      type="button"
                      onClick={() => { this.loadInBrowser() }}
                    >
                      <SvgAssets icon="icon-download-file" fill={color.naranja} />Descargar manual
                    </button>
                  </div>
                  : <h6 className="title desktop_parrafo1 morado">
                    Resultado obtenido:
                    <TooltipLeyenda
                      color={color.azulClaro}
                      style={{ position: 'absolute', right: 50, top: -2 }}
                    />
                  </h6>
                }

              </div>
              : null}
            {
              isSearch == true ?
                <div className="resultados cards-wrap">
                  {dataResult.repuestos?.length == 0 ?
                    <p className="error-1 container" style={{ color: color.rojoClaro }}>No se han encontrado resultados, por favor intente nuevamente</p>
                    :
                    dataResult.repuestos.map((item, index) => {
                      let card = (
                        <CardResultado
                          key={index}
                          item={item}
                          event={this.postAgregarProductoPedido}
                          eventCounter={this.setCounter}
                          eventFavorito={this.postAgregarProductoFavorito}
                          auth={auth}
                          zoom={this.toggleModalZoom}
                          kit={this.toggleModalKit}
                          compatible={this.toggleModalCompatible} />
                      );

                      if (tipoBuscador == 2) {
                        card = (
                          <CardRepuestos
                            key={index}
                            item={item}
                            event={this.loadIrRepuestos}
                            zoom={this.toggleModalZoom}
                          // eventCounter={dadComponent.setCounter} 
                          />
                        )
                      }

                      return card;
                    })
                  }
                </div>
                : null}
            {(dataResult.repuestos.length > 0) ? <Pagination event={tipoBuscador == 1 ? this.setPageDescripcion : this.setPageVehiculo} current={page} currentPage={currentPage} totalPage={dataResult.repuestos[0].totalPage} size={data.PageSizePaginator} /> : null}
            {
              dataResult != null ?
                dataResult.destacados != null ?
                  dataResult.destacados.length > 0 ?
                    <section className="productos_destacados">
                      <SvgAssets icon="curve-bottom" className='curve-top' fill="#fff" />
                      <h6 className="title desktop_parrafo1" style={{ color: '#fff' }}>Productos destacados {dataResult.destacados.length}<TooltipLeyenda color={'#fff'} style={{ position: 'absolute', right: 0, top: -2 }} /></h6>
                      <Slider ref={c => (this.SLIDER_DESTACADOS = c)} {...slider_destacados}>
                        {
                          dataResult.destacados.map((carousel, index) => {
                            return (
                              <ProductoDestacado key={index} item={carousel} index={index} event={this.postAgregarProductoPedido} eventCounter={this.setCounter} eventFavorito={this.postAgregarProductoFavorito} auth={auth} zoom={this.toggleModalZoom} tipoBuscador={tipoBuscador} compatible={this.toggleModalCompatible} />
                            )
                          })
                        }
                      </Slider>
                      <div className="arrows-slider">
                        <button className="btn-icon" onClick={() => this.SLIDER_DESTACADOS.slickPrev()}><SvgAssets icon="icon-left" fill='#fff' /></button>
                        <button className="btn-icon" onClick={() => this.SLIDER_DESTACADOS.slickNext()}><SvgAssets icon="icon-right" fill='#fff' /></button>
                      </div>
                      <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
                    </section>
                    : null
                  : null
                : null
            }
            {
              dataResult != null ?
                dataResult.vendidos != null ?
                  dataResult.vendidos.length > 0 ?
                    <section className="productos_vendidos">
                      <h6 className="title desktop_parrafo1" style={{ color: color.rojoClaro }}>Los Productos más comprados<TooltipLeyenda color={color.azulClaro} style={{ position: 'absolute', right: 0, top: -2 }} /></h6>
                      <Slider ref={c => (this.SLIDER_COMPRADOS = c)} {...slider_vendidos} className="dots_blue">
                        {
                          dataResult.vendidos.map((carousel, index) => {
                            return (
                              <ProductoVendido key={index} item={carousel} index={index} event={this.postAgregarProductoPedido} eventCounter={this.setCounter} eventFavorito={this.postAgregarProductoFavorito} auth={auth} zoom={this.toggleModalZoom} />
                            )
                          })
                        }
                      </Slider>
                      <div className="arrows-slider">
                        <button className="btn-icon" onClick={() => this.SLIDER_COMPRADOS.slickPrev()}><SvgAssets icon="icon-left" fill={color.azulClaro} /></button>
                        <button className="btn-icon" onClick={() => this.SLIDER_COMPRADOS.slickNext()}><SvgAssets icon="icon-right" fill={color.azulClaro} /></button>
                      </div>
                    </section>
                    : null
                  : null
                : null
            }
          </div>
        </div>
        <ModalAddCart dadComponent={this} dataToCard={this.state.dataToCard} />
        <ModalImageZoom2 dadComponent={this} />
        <ModalKit dadComponent={this} detalleKit={this.state.dataResult.detalleKit} />
        <ModalCompatible dadComponent={this} texto={this.state.mensajeCompatible} />
      </div>
    );

    if (isMobile) {
      component = (
        <Container className="py-5">
          <Spinner visible={loading} />
          <h6 className="title white">Generar pedido</h6>
          <div className="card_busqueda_pedido">
            <div className="textContent">
              <div className="custom-control custom-radio custom-control-inline terminos">
                <input
                  type="radio"
                  id="radio1"
                  name="radio_ln"
                  className="custom-control-input"
                  checked={tipoBuscador == 1}
                  onChange={() => this.seleccionarBuscador(1)}
                />
                <label className="custom-control-label naranja" htmlFor="radio1"></label>
              </div>
              <div>
                <h6 className="paragraph-2 morado bold">Buscador por Código</h6>
                <p>Esta opción te permitirá realizar búsquedas de repuestos por código o descripción.</p>
              </div>
              <SvgAssets icon="icon-codigo" fill={color.morado} />
            </div>
            <form className="busqueda-pedido" style={{ backgroundColor: color.morado }}>
              <SvgAssets icon="curve-top" className='curve-top' fill={color.morado} />
              <FormGroup className="mb-0">
                <Input type="text" name="descripcion" placeholder="SKU o Descripción" className="morado"
                  readOnly={!(tipoBuscador == 1)}
                  value={textBuscador}
                  onChange={(textBuscador) => this.setText(textBuscador)}
                  onKeyPress={(e) => { if (e.which == 13 || e.which == 10) e.preventDefault(); }}
                  onKeyUp={(e) => { if (e.keyCode == 13 || e.keyCode == 10) { e.preventDefault(); this.IrBuscar(1, isMobile); } }}
                />
                {/* <Link to="/buscador-codigo" style={{ textDecoration: 'none' }}> */}
                <button
                  type="button"
                  className='btn-icon rounded mt-0'
                  onClick={() => { this.IrBuscar(1, isMobile) }}
                  disabled={tipoBuscador != 1}>
                  <SvgAssets icon="icon-lupa" fill="#fff" />
                </button>
                {/* </Link> */}
              </FormGroup>
              {(errorCodigo) ? <FormFeedback style={{ color: '#fff' }}>Debe incluir al menos 5 caracteres, si requiere puede completar dicha cantidad colocando <span className="bold">espacios en blanco</span> al final</FormFeedback> : null}
            </form>
          </div>
          <div className="card_busqueda_pedido">
            <div className="textContent">
              <div className="custom-control custom-radio custom-control-inline terminos">
                <input
                  type="radio"
                  id="radio2"
                  name="radio_ln"
                  className="custom-control-input"
                  checked={tipoBuscador == 2}
                  onChange={() => this.seleccionarBuscador(2)}
                />
                <label className="custom-control-label naranja" htmlFor="radio2"></label>
              </div>
              <div>
                <h6 className="paragraph-2 verde bold">Buscador por Vehículo</h6>
                <p>Esta opción te permitirá realizar búsquedas de repuestos por vehículo.</p>
              </div>
              <SvgAssets icon="icon-moto" fill={color.verdeClaro} />
            </div>
            <form className="busqueda-pedido" style={{ backgroundColor: color.verdeClaro }}>
              <SvgAssets icon="curve-top" className='curve-top' fill={color.verdeClaro} />
              <FormGroup>
                <Input
                  type="select"
                  name="select"
                  className="verde"
                  style={{ flex: 0.5 }}
                  disabled={tipoBuscador == 1}
                  value={selectedAnioValue}
                  onChange={(itemValue, itemIndex) => this.setSelectedValue(itemValue, data.FiltroPedito.ComboAnio)}
                >
                  <option>Año</option>
                  {(filtroAnio.length > 0) ? filtroAnio.map((data, index) => {
                    return (
                      <option key={index + 1} value={data.id}>{data.descripcion}</option>
                    )
                  }) : null}
                </Input>
                <Input
                  type="select"
                  name="select"
                  className="verde ml-2"
                  disabled={tipoBuscador != 2}
                  value={selectedModeloValue}
                  onChange={(itemValue, itemIndex) => this.setSelectedValue(itemValue, data.FiltroPedito.ComboModelo)}>
                  <option>Modelo</option>
                  {(filtroModelo.length > 0) ? filtroModelo.map((data, index) => {
                    return (
                      <option key={index + 1} value={data.id}>{data.descripcion}</option>
                    )
                  }) : null}
                </Input>
              </FormGroup>
              <FormGroup className="mb-0">
                <Input
                  type="select"
                  name="select"
                  className="verde"
                  disabled={tipoBuscador != 2}
                  value={selectedVehiculoValue}
                  onChange={(itemValue, itemIndex) => this.setSelectedValue(itemValue, data.FiltroPedito.ComboVehiculo)}>
                  <option>Vehículo</option>
                  {(filtroVehiculo.length > 0) ? filtroVehiculo.map((data, index) => {
                    return (
                      <option key={index + 1} value={data.descripcion} >{data.descripcion}</option>
                    )
                  }) : null}
                </Input>
                {/* <Link to="/buscador-vehiculo" style={{ textDecoration: 'none' }}> */}
                <button className='btn-icon rounded'
                  type="button"
                  onClick={() => { this.IrBuscar(2, isMobile) }}
                  disabled={tipoBuscador != 2}>
                  <SvgAssets icon="icon-lupa" fill="#fff" />
                </button>
                {/* </Link> */}
              </FormGroup>
              {(errorVehiculo) ? <p className="text-danger">Debe seleccionar el año, modelo y vehículo</p> : null}
            </form>
          </div>
          <Link className='btn-block bg_transparent' to="/pedido-sugerido">PEDIDO SUGERIDO</Link>
          <Link className='btn-block bg_transparent' to="/pre-pedidos">PRE-PEDIDO<br />(Pasar Pre-Pedido)</Link>
          <Link className='btn-block bg_transparent' to={
            {
              pathname: "/historial-pedidos",
              state: { estad: null }
            }
          }>
            REPETIR PEDIDO ANTERIOR
          </Link>
          {/* <button className='btn-block bg_transparent'>PEDIDO SUGERIDO</button>
        <button className='btn-block bg_transparent'>PRE-PEDIDO<br />(Pasar Pre-Pedido)</button>
        <button className='btn-block bg_transparent'>REPETIR PEDIDO ANTERIOR</button> */}
          <ModalAddCart dadComponent={this} dataToCard={this.state.dataToCard} />
        </Container>
      )
    }

    return component;
  }

  setText(e) {
    let value = e.currentTarget.value;
    // this.setState({ errorCodigo: false, errorVehiculo: false, textBuscador: value, filtroAnio: [], filtroModelo: [], filtroVehiculo: [] })
    this.setState({ errorCodigo: false, errorVehiculo: false, textBuscador: value })
  }

  IrBuscar(value, isMobile) {
    let datosBuscador = {}

    this.setState({ loading: true, isSearch: false, tipoBuscador: value, dataResult: { repuestos: [], destacados: [], vendidos: [] }, page: 1, currentPage: 1 });

    if (value == 1) {
      let errorCodigo = (this.state.textBuscador == null || this.state.textBuscador.length < data.BuscadorCodigoLongitud);
      this.setState({
        errorCodigo: errorCodigo,
        errorVehiculo: false,
        selectedAnioValue: "",
        selectedModeloValue: "",
        selectedVehiculoValue: "",
        loading: false,
        params: {},
      })
      if (!errorCodigo) {
        datosBuscador = {
          text: this.state.textBuscador,
        }

        if (isMobile) {
          this.props.history.push({
            pathname: '/buscador-codigo',
            state: {
              datosBuscador
            }
          });
        }
        else {
          this.postBuscarCodigoDescripcionPrincipal(this.state.dealer, this.state.linea, this.state.asociado, this.state.textBuscador, 1);
        }
      }
    } else {

      if (this.state.selectedAnioValue == null || this.state.selectedAnioValue == "" ||
        this.state.selectedModeloValue == null || this.state.selectedModeloValue == "" ||
        this.state.selectedVehiculoValue == null || this.state.selectedVehiculoValue == "") {
        this.setState({
          errorCodigo: false,
          errorVehiculo: true,
          loading: false
        })
      } else {
        this.setState({
          errorCodigo: false,
          errorVehiculo: false,
          textBuscador: "",
          loading: false
        })
        datosBuscador = { filtroAnio: [], filtroModelo: [], filtroVehiculo: [] }
        let dataParametro = {
          filtroAnio: this.state.filtroAnio,
          filtroModelo: this.state.filtroModelo,
          filtroVehiculo: this.state.filtroVehiculo,
          selectedAnioValue: this.state.selectedAnioValue,
          selectedModeloValue: this.state.selectedModeloValue,
          selectedVehiculoValue: this.state.selectedVehiculoValue
        }


        if (isMobile) {
          this.props.history.push({
            pathname: '/buscador-vehiculo',
            state: {
              dataParametro
            }
          });
        } else {
          this.setFiler();
        }
        // this.props.navigation.navigate('BuscadorVehiculo', { dataParametro });
      }
    }

  }
  seleccionarBuscador(value) {
    if (value == 1)
      this.setState({ errorCodigo: false, errorVehiculo: false, tipoBuscador: value, filtroAnio: [], filtroModelo: [], filtroVehiculo: [] })
    else {
      this.setState({ errorCodigo: false, errorVehiculo: false, tipoBuscador: value, textBuscador: '' })
      this.getAnios(data.FiltroPedito.ComboAnio);
    }
  }
  setSelectedValue(e, ETipoFiltro) {
    let value = e.currentTarget.value;
    switch (ETipoFiltro) {
      case data.FiltroPedito.ComboAnio:
        this.setState({ selectedAnioValue: value, selectedModeloValue: '', selectedVehiculoValue: '', filtroModelo: [], filtroVehiculo: [] })
        this.getFiltros(data.FiltroPedito.ComboModelo, value);
        break;
      case data.FiltroPedito.ComboModelo:
        this.setState({ selectedModeloValue: value, selectedVehiculoValue: '', filtroVehiculo: [] })
        this.getFiltros(data.FiltroPedito.ComboVehiculo, this.state.selectedAnioValue, value);
        break;
      case data.FiltroPedito.ComboVehiculo:
        this.setState({ selectedVehiculoValue: value })
        break;
      default:
        break;
    }
  }
  getAnios = (ETipoFiltro) => {
    this.setState({ loading: true })
    getDataFiltros(ETipoFiltro)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false, filtroAnio: result.dto.filtro })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Generar Pedidos", error.message ?? null);
        });
      });
  }

  getFiltros = async (ETipoFiltro, Anio, Modelo, FlagCargarDatos) => {
    switch (ETipoFiltro) {
      case data.FiltroPedito.ComboModelo:
        if (Anio == null || Anio == "" || Anio == undefined) return;
        break;
      case data.FiltroPedito.ComboVehiculo:
        if (Anio == null || Anio == "" || Anio == undefined ||
          Modelo == null || Modelo == "" || Modelo == undefined) return;
        break;
      default:
        break;
    }
    this.setState({ loading: true })
    getDataFiltros(ETipoFiltro, Anio, Modelo)
      .then(result => {
        if (result.mo.type == "success") {
          switch (ETipoFiltro) {
            // case data.FiltroPedito.ComboAnio:
            // this.setState({ loading: false, filtroAnio: result.dto.filtro })          
            // this.setState({ loading: false, filtroModelo: result.dto.filtro })
            // break;
            case data.FiltroPedito.ComboModelo:
              this.setState({ loading: false, filtroModelo: result.dto.filtro })
              break;
            case data.FiltroPedito.ComboVehiculo:
              this.setState({ loading: false, filtroVehiculo: result.dto.filtro }, () => {
                if (FlagCargarDatos) {
                  this.setState({ page: this.state.params.page, errorVehiculo: false })
                  let selectedVehiculo = this.state.filtroVehiculo.filter(p => p.descripcion == this.state.selectedVehiculoValue)[0];
                  console.log("selectedVehiculo======>", selectedVehiculo);
                  let dealer = this.state.dealer;
                  let linea = this.state.linea;
                  let asociado = this.state.asociado;
                  let indexPage = this.state.params.page;
                  this.setState({ loading: true })

                  BuscarSistemaPrincipal(dealer.codcliente, linea.vkorg, dealer.correoElectronico,
                    selectedVehiculo.id, selectedVehiculo.descripcion, linea.centro,
                    asociado.moneda, asociado.poblacion, indexPage)
                    .then(result => {
                      if (result.mo.type == "success") {
                        let _data = this.state.dataResult;
                        this.setState({
                          isSearch: true,
                          loading: false,
                          dataResult: {
                            repuestos: result.dto.sistema,
                            destacados: result.dto.productosDestacados,
                          },
                          titulo: result.dto.sistema[0].catalogo,
                          pdf: result.dto.sistema[0].linkpdf,
                          selectedVehiculoValueOriginal: selectedVehiculo.id
                        })

                      } else {
                        throw new Error(result.mo.listMessage.join(", "));
                      }
                    }).catch((error) => {
                      this.setState({ loading: false }, async () => {
                        error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
                        notificacion("Buscador", error.message ?? null);
                      });
                    });
                }
              })
              break;
            default:
              break;
          }
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Generar Pedidos", error.message ?? null);
        });
      });
  }
  postBuscarKit = (dealer, linea, Matnr) => {
    this.setState({ loading: true })
    BuscarKit(dealer, linea, Matnr)
      .then(result => {
        if (result.mo.type == "success") {
          let _repuestos = this.state.dataResult.repuestos
          let _destacados = this.state.dataResult.destacados
          let _vendidos = this.state.dataResult.vendidos
          this.setState({
            dataResult: {
              detalleKit: result.dto.detalleKit,
              repuestos: _repuestos,
              destacados: _destacados,
              vendidos: _vendidos,
            },
            loading: false,
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Buscador", error.message ?? null);
        });
      });
  }
  postAgregarProductoPedido = async (carritoProdctos, setcarritoProdctos, producto) => {
    this.setState({ loading: true })
    AgregarProductoPedido(this.state.dealer,
      producto,
      this.state.linea,
      this.state.asociado
    )
      .then(result => {
        if (result.mo.type == "success") {

          let _repuestos = this.state.dataResult.repuestos
          let _destacados = this.state.dataResult.destacados
          let _vendidos = this.state.dataResult.vendidos

          if (producto.pantalla == data.Pantalla.BuscarPedidoCodigo.Destacado)
            _destacados[producto.indice].cantidad = 0;
          else if (producto.pantalla == data.Pantalla.BuscarPedidoCodigo.Vendido)
            _vendidos[producto.indice].cantidad = 0;
          else if (producto.pantalla == data.Pantalla.BuscarPedidoCodigo.Producto)
            _repuestos[producto.indice].cantidad = 0;

          this.setState({
            dataResult: {
              repuestos: _repuestos,
              destacados: _destacados,
              vendidos: _vendidos,
            },
            loading: false,
            addToCart: true,
            dataToCard: producto
          })
          setcarritoProdctos(result.dto.carritoProdctos);
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Alerta", error.message ?? null);
        });
      });
  }

  postBuscarCodigoDescripcionPrincipal = (dealer, linea, asociado, textBuscador, index) => {
    this.setState({
      loading: true
    })
    BuscarCodigoDescripcionPrincipal(linea.centro, dealer.codcliente,
      textBuscador, asociado.moneda, linea.vkorg,
      asociado.poblacion, dealer.correoElectronico,
      index)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            isSearch: true,
            dataResult: {
              repuestos: result.dto.repuestos,
              destacados: result.dto.productosDestacados,
              vendidos: result.dto.productosMasComprados
            }
          })
          console.log("result.dto.productosDestacados====>", result.dto.productosDestacados);
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Buscador", error.message ?? null);
        });
      });
  }

  postBuscarCodigoDescripcion = (dealer, linea, asociado, textBuscador, indexPage) => {

    let _textBuscador = this.state.textBuscador;
    let _textBuscadorOri = this.state.textBuscadorOri;



    this.setState({ loading: true })
    BuscarCodigoDescripcion(linea.centro, dealer.codcliente,
      textBuscador, asociado.moneda, linea.vkorg,
      asociado.poblacion, dealer.correoElectronico,
      indexPage)
      .then(result => {
        if (result.mo.type == "success") {
          let _data = this.state.dataResult;
          this.setState({
            loading: false,
            dataResult: {
              repuestos: result.dto.repuestos,
              destacados: _data.destacados,
              vendidos: _data.vendidos
            }
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Buscador", error.message ?? null);
        });
      });
  }
  postAgregarProductoFavorito = (producto, AplicaFavorito, index) => {
    this.setState({ loading: true })
    AgregarProductoFavorito(this.state.dealer, producto, this.state.linea, !AplicaFavorito
    )
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false })
          let _data = this.state.dataResult
          let _repuestos = _data.repuestos
          let _destacados = _data.destacados
          let _vendidos = _data.vendidos

          if (producto.pantalla == data.Pantalla.BuscarPedidoCodigo.Destacado)
            _destacados[index].favorito = !AplicaFavorito;
          else if (producto.pantalla == data.Pantalla.BuscarPedidoCodigo.Vendido)
            _vendidos[index].favorito = !AplicaFavorito;
          else if (producto.pantalla == data.Pantalla.BuscarPedidoCodigo.Producto)
            _repuestos[index].favorito = !AplicaFavorito;

          this.setState({
            dataResult: {
              repuestos: _repuestos,
              destacados: _destacados,
              vendidos: _vendidos
            }
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Buscador", error.message ?? null);
        });
      });
  }

  setCounter = (counter, tab, index) => {
    let _data = this.state.dataResult
    let _repuestos = _data.repuestos
    let _destacados = _data.destacados
    let _vendidos = _data.vendidos
    if (counter == "") {
      if (data.Pantalla.BuscarPedidoCodigo.Producto == tab)
        _repuestos[index].cantidad = 0;
      else if (data.Pantalla.BuscarPedidoCodigo.Destacado == tab)
        _destacados[index].cantidad = 0;
      else if (data.Pantalla.BuscarPedidoCodigo.Vendido == tab)
        _vendidos[index].cantidad = 0;
    } else {
      if (data.Pantalla.BuscarPedidoCodigo.Producto == tab)
        _repuestos[index].cantidad = counter;
      else if (data.Pantalla.BuscarPedidoCodigo.Destacado == tab)
        _destacados[index].cantidad = counter;
      else if (data.Pantalla.BuscarPedidoCodigo.Vendido == tab)
        _vendidos[index].cantidad = counter;
    }

    this.setState({
      dataResult: {
        repuestos: _repuestos,
        destacados: _destacados,
        vendidos: _vendidos
      }
    })

  }
  // setActiveSlidePD = (index) => {
  //   this.setState({ activeSlidePD: index })
  // }

  // setActiveSlidePV = (index) => {
  //   this.setState({ activeSlidePV: index })
  // }

  setPageDescripcion = (index, change, type) => {
    if (change) {
      let _currentPage = this.state.currentPage
      this.setState({ page: index, currentPage: type == "add" ? (_currentPage + 1) : (_currentPage - 1) })
    }
    else
      this.setState({ page: index })

    console.log("Index 22===>", index);
    this.postBuscarCodigoDescripcion(this.state.dealer, this.state.linea, this.state.asociado, this.state.textBuscador, index);

  }

  setPageVehiculo = (index, change, type) => {
    if (change) {
      let _currentPage = this.state.currentPage
      this.setState({ page: index, currentPage: type == "add" ? (_currentPage + 1) : (_currentPage - 1) })
    }
    else
      this.setState({ page: index })

    let selectedVehiculo = this.state.filtroVehiculo.filter(p => p.descripcion == this.state.selectedVehiculoValue)[0];
    this.postBuscarSistema(this.state.dealer, this.state.linea, this.state.asociado, selectedVehiculo, index, false);
  }

  setFiler = () => {
    if (this.state.selectedAnioValue == null || this.state.selectedAnioValue == "" ||
      this.state.selectedModeloValue == null || this.state.selectedModeloValue == "" ||
      this.state.selectedVehiculoValue == null || this.state.selectedVehiculoValue == "") {
      this.setState({
        errorVehiculo: true
      })
    }
    else {
      this.setState({ page: 1, errorVehiculo: false })
      let selectedVehiculo = this.state.filtroVehiculo.filter(p => p.descripcion == this.state.selectedVehiculoValue)[0];
      this.postBuscarSistema(this.state.dealer, this.state.linea, this.state.asociado, selectedVehiculo, 1, true);
    }
  }

  postBuscarSistema = async (dealer, linea, asociado, selectedVehiculo, indexPage, isButton) => {

    let _textBuscador = this.state.selectedVehiculoValue;
    let _textBuscadorOri = this.state.selectedVehiculoValueOriginal;

    if (isButton) {
      this.setState({
        size: data.PageSize,
        currentPage: 1,
        page: 1,
        selectedVehiculoValueOriginal: _textBuscador
      })
      indexPage = 1
    }

    this.setState({ loading: true })
    BuscarSistemaPrincipal(dealer.codcliente, linea.vkorg, dealer.correoElectronico,
      selectedVehiculo.id, selectedVehiculo.descripcion, linea.centro,
      asociado.moneda, asociado.poblacion, indexPage)
      .then(result => {
        if (result.mo.type == "success") {
          let _data = this.state.dataResult;
          this.setState({
            isSearch: true,
            loading: false,
            dataResult: {
              repuestos: result.dto.sistema,
              destacados: result.dto.productosDestacados,
            },
            titulo: result.dto.sistema[0].catalogo,
            pdf: result.dto.sistema[0].linkpdf,
            selectedVehiculoValueOriginal: selectedVehiculo.id
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador", error.message ?? null);
        });
      });
  }
  loadIrRepuestos = (item) => {
    let datosBuscador = {
      page: this.state.page,
      Catalogo: item.catalogo,
      Linkimg: item.linkimg,
      Pagina: item.pagina,
      Sistemaweb: item.sistemaweb,
      addToCart: false,
      selectedAnioValue: this.state.selectedAnioValue,
      selectedModeloValue: this.state.selectedModeloValue,
      selectedVehiculoValue: this.state.selectedVehiculoValue,
      dataToCard: {}
    }

    this.props.history.push({
      pathname: '/repuestos',
      state: { datosBuscador }
    });
  };
}
